import React from 'react'
import SpecializeBilling from './SpecializeBilling/SpecializeBilling'
import MissionVisison from './MissionVisison/MissionVisison'
import Faqs from './Faqs/Faqs'
import Appointment from '../Home/Appointment/Appointment'

const AboutUs = () => {
  return (
    <>
     <SpecializeBilling/>
     <MissionVisison/>
     <Faqs/>
     <Appointment/>
    </>
  )
}

export default AboutUs
